import type {
  SsoCallbackTestStartRequest,
  SsoCallbackTestStartResponse,
  SsoCallbackTestTarget,
  SsoProviderUpdateRequest,
  SsoProviderUpdateResponse,
  SsoSettingsResponse,
  SsoSignInErrorResponse,
  SsoTestConnectionRequest,
  SsoTestConnectionResponse,
} from "@repo/shared/types";
import { del, get, post, put } from "./_client";

export function getSsoProvider() {
  return get<SsoSettingsResponse>("/internal/sso");
}

export function updateSsoProvider(data: SsoProviderUpdateRequest) {
  return put<SsoProviderUpdateResponse>("/internal/sso", data satisfies SsoProviderUpdateRequest);
}

/** Start a test sign-in through the current or pending (QL-345) callback URL. */
export function startSsoCallbackTest(target: SsoCallbackTestTarget) {
  return post<SsoCallbackTestStartResponse>("/internal/sso/test-sign-in", {
    target,
  } satisfies SsoCallbackTestStartRequest);
}

/** QL-345 — the IdP has the new callback URL after a slug rename: switch SSO to it. */
export function confirmSsoProviderIdChange() {
  return post<SsoSettingsResponse>("/internal/sso/confirm-provider-id");
}

export function deleteSsoProvider() {
  return del<{ success: boolean }>("/internal/sso");
}

export function testSsoConnection(issuerUrl: string) {
  return post<SsoTestConnectionResponse>("/internal/sso/test-connection", {
    issuerUrl,
  } satisfies SsoTestConnectionRequest);
}

/** QL-637 — what the API recorded for a failed (test) sign-in, by reference. */
export function getSsoSignInError(ref: string) {
  return get<SsoSignInErrorResponse>(`/internal/sso/sign-in-errors/${encodeURIComponent(ref)}`);
}
